import styled from 'styled-components';
import { Bar } from '@ant-design/plots';

export const LineBar = styled(Bar).attrs({
  color: '#d3adf7',
  barStyle: {
    stroke: '#9254de',
  },
  xAxis: {
    label: {
      autoHide: true,
      autoRotate: false,
      style: {
        fill: '#000',
      },
    },
  },
  yAxis: {
    label: {
      style: {
        fill: '#000',
      },
    },
  },
})``;
